export default __webpack_public_path__ + "static/3-9d098aef0f516748062a6c9603da9138.png";